import React from 'react';
import PropTypes from 'prop-types';

const AccentSection = ({ title, children, accent = 'blue', className = '' }) => {
  const accentColors = {
    blue: 'border-blue-500',
    purple: 'border-purple-500',
    indigo: 'border-indigo-500',
    green: 'border-green-500',
    yellow: 'border-yellow-500',
    red: 'border-red-500',
    pink: 'border-pink-500',
    orange: 'border-orange-500',
  };

  return (
    <div className={`border-l-4 ${accentColors[accent]} pl-6 ${className}`}>
      <h4 className="text-sm font-semibold text-[var(--succession-text-primary)] uppercase tracking-wide mb-2">
        {title}
      </h4>
      <div className="text-[var(--succession-text-secondary)] text-sm leading-relaxed">
        {children}
      </div>
    </div>
  );
};

AccentSection.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  accent: PropTypes.oneOf(['blue', 'purple', 'indigo', 'green', 'yellow', 'red', 'pink', 'orange']),
  className: PropTypes.string,
};

AccentSection.defaultProps = {
  accent: 'blue',
  className: '',
};

export default AccentSection;

